<div class="wo">
  <header class="wo-hero">
    <img
      class="wo-hero-img"
      src="assets/woyp/woyp-meet-1000.jpg"
      srcset="assets/woyp/woyp-meet-1000.jpg 1000w, assets/woyp/woyp-meet-2000.jpg 2000w"
      sizes="100vw"
      alt="People chatting around a classic car at a car meet"
    />
    <div class="wo-hero-shade"></div>
    <div class="wo-hero-copy">
      <p class="wo-eyebrow">A PlateX initiative</p>
      <h1 class="wo-logo" aria-label="What's on your plate? Ask a mate.">
        <span class="wo-logo-caps">What's on your</span>
        <span class="wo-logo-plate">
          <span class="wo-logo-hand">plate</span>
          <span class="wo-dots"><i></i><i></i><i></i></span>
        </span>
        <span class="wo-logo-ask">ask a mate</span>
      </h1>
      <p class="wo-lead">
        Your plate is the registration on your car. It is also everything you are carrying that other people
        can't see.
      </p>
    </div>
  </header>

  <div class="wo-body">
    <section class="wo-lede">
        <p class="wo-intro">
          What's on Your Plate is how PlateX supports UK charities working in mental health and suicide prevention.
          We support three charities that are there for people when it matters most: Samaritans, Mind and
          ANDYSMANCLUB.
        </p>
    </section>

    <main class="wo-main">
      <section class="wo-section">
        <h2 class="wo-h2">Why it matters to us</h2>
        <p class="wo-text">
          Cars bring people together. Car meets, club runs, a chat on the driveway about a new registration: for a
          lot of people, and for a lot of men in particular, that is where the conversation happens.
        </p>
        <p class="wo-text">
          It is also a world where it can be hard to say you are not OK. Behind the banter, people carry money
          worries, grief, loneliness and pressure they don't talk about.
        </p>
        <p class="wo-text">
          We spend our days on registrations: names, dates, families, memories. Behind every plate is a person.
          What's on Your Plate is how our work helps the people behind the plates, and how we help keep the
          conversation going.
        </p>
      </section>

      <section class="wo-section wo-talk">
        <div class="wo-talk-copy">
          <h2 class="wo-h2">It starts with a question</h2>
          <p class="wo-text">
            Reaching out matters. Asking a friend how they are, and really listening to the answer, can be the first
            step towards getting help. You don't need the right words. You need to ask, and then give them time.
          </p>
          <p class="wo-text">
            Sometimes the answer is fine. Sometimes it is debt, grief, loss, stress or fear. Either way, the
            conversation has started.
          </p>
        </div>
        <figure class="wo-convo">
          <p class="wo-ask">
            <span class="wo-ask-caps">What's on your</span>
            <span class="wo-ask-hand">plate?</span>
          </p>
          <div class="wo-answer" aria-hidden="true">
            <span class="wo-answer-plate" *ngFor="let a of [answer]" [class.wo-answer-plate--waiting]="!a">
              <ng-container *ngIf="a; else waiting">{{ a }}</ng-container>
            </span>
            <ng-template #waiting>
              <span class="wo-dots"><i></i><i></i><i></i></span>
            </ng-template>
          </div>
          <figcaption class="wo-convo-cap">Ask the question. Then listen to the answer.</figcaption>
        </figure>
      </section>

      <section class="wo-section">
        <div class="wo-help">
          <h2 class="wo-help-h">If you need to talk to someone now</h2>
          <p class="wo-text">
            <strong>Samaritans</strong> are there day and night on <a class="wo-link" href="tel:116123">116 123</a>,
            free from any phone.
          </p>
          <p class="wo-text">
            <strong>ANDYSMANCLUB</strong> runs free groups for men every Monday at 7pm.
            <a class="wo-link" href="https://andysmanclub.co.uk" target="_blank" rel="noopener">Find a group</a>.
          </p>
          <p class="wo-text">If someone's life is at risk, call 999.</p>
        </div>
      </section>
    </main>

    <aside class="wo-aside" aria-labelledby="wo-charities-h">
      <div class="wo-aside-inner">
        <h2 class="wo-aside-h" id="wo-charities-h">The charities we support</h2>
        <article class="wo-charity" *ngFor="let c of beneficiaries">
          <a class="wo-charity-logo" [href]="c.url" target="_blank" rel="noopener" [attr.aria-label]="c.name">
            <img [src]="c.logo" [alt]="c.name" loading="lazy" />
          </a>
          <h3 class="wo-charity-name">{{ c.name }}</h3>
          <p class="wo-charity-text">{{ c.summary }}</p>
          <p class="wo-charity-no">Registered charity {{ c.charityNumber }}</p>
        </article>
      </div>
    </aside>
  </div>

  <footer class="wo-foot">
    <p>
      PlateX is not a registered charity. Charity names and logos are shown to identify the charities we support.
    </p>
    <p>Photo: Geike Verniers on Unsplash.</p>
    <p *ngIf="guides"><a class="wo-link" routerLink="/market-guides">PlateX Market Guides</a></p>
  </footer>
</div>
